// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"16":"select-avatar","86":"main-menu","238":"testing","774":"select-language"}[chunkId] || chunkId) + "." + {"16":"51088727","86":"406da661","238":"3a69df9f","709":"d871f78f","774":"31be36a2"}[chunkId] + ".js";
};